module.exports = __webpack_public_path__ + "img/yjfk.396579b2.svg";